export default __webpack_public_path__ + "static/media/ic-store.12fb57dd.svg";